export const ClinicType = {
  STANDALONE: "STANDALONE",
  CHAIN: "CHAIN",
};

export const Status = {
  PENDING: "PENDING",
  LOCKED: "LOCKED",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const MRP_STATUS = {
  DRAFT: "DRAFT",
  CONVERTED: "CONVERTED",
  CANCELED: "CANCELED",
};

export const PR_STATUS = {
  DRAFT: "DRAFT",
  SENT_TO_ERP: "SENT_TO_ERP",
  PARTIALLY_ORDERED: "PARTIALLY_ORDERED",
  CLOSED: "CLOSED",
  CANCELED: "CANCELED",
};

export const PO_STATUS = {
  DRAFT: "DRAFT",
  PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
  CLOSED: "CLOSED",
  EARLY_CLOSED: "EARLY_CLOSED",
  CANCELED: "CANCELED",
  AMENDED_AND_CLOSED: "AMENDED_AND_CLOSED",
};

export const ADJUSTMENT_STATUS = {
  WAITING_BM: "WAITING_BM",
  WAITING_HQ: "WAITING_HQ",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
};

export const STOCK_TYPE = Object.freeze({
  GENERAL: 0,
  RETURN: 1,
  PHYSICAL_COUNT: 2,
  WITHDRAW: 3,
});

export const STOCK_TYPE_API_NAME = Object.freeze({
  [STOCK_TYPE.GENERAL]: "GENERAL",
  [STOCK_TYPE.RETURN]: "RETURN",
  [STOCK_TYPE.PHYSICAL_COUNT]: "PHYSICAL_COUNT",
  [STOCK_TYPE.WITHDRAW]: "WITHDRAW",
});

export const STOCK_TYPE_NAME = Object.freeze({
  GENERAL: "GENERAL",
  RETURN: "RETURN",
  PHYSICAL_COUNT: "PHYSICAL_COUNT",
  WITHDRAW: "WITHDRAW",
});

export const STOCK_TYPE_FROM_API = Object.freeze({
  GENERAL: STOCK_TYPE.GENERAL,
  RETURN: STOCK_TYPE.RETURN,
  PHYSICAL_COUNT: STOCK_TYPE.PHYSICAL_COUNT,
  WITHDRAW: STOCK_TYPE.WITHDRAW,
});

export const GR_STATUS = {
  WAITING_BM: "WAITING_BM",
  WAITING_HQ: "WAITING_HQ",
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
  COMPLETED: "COMPLETED",
};